export default {
  "config": {
    "trial": "driving",
    "id": "study-design",
    "type": "design",
    "title": "Evaluation of Effect of Solriamfetol on On-Road Driving Performance in Participants with EDS Associated with OSA<sup>29</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
      "The driving test could be stopped by the participant or by the accompanying driving instructor if either considered it unsafe to continue. Medications that affect sleep-wake functions (eg, sleep aids, stimulants) were prohibited for 7 days prior to the screening MWT and during the study."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "driving",
    "id": "study-design",
    "data-type": "design",
    "title": "Evaluation of Effect of Solriamfetol on On-Road Driving Performance in Participants with EDS Associated with OSA<sup>29</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
    "footnote-note2": "The driving test could be stopped by the participant or by the accompanying driving instructor if either considered it unsafe to continue. Medications that affect sleep-wake functions (eg, sleep aids, stimulants) were prohibited for 7 days prior to the screening MWT and during the study."
  }
};